<div *ngIf="isDeletable()" class="delete" (click)="onClick()">
  <div id="delete-icon"></div>
</div>
